




























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class LineButton extends Vue {
    @Prop() private userConfigColor! : string;

    setIsSelectLineVisible(){
        this.$emit("setIsSelectLineVisible");
    }
}
